var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLocalisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.798 93.79"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-90.021 -883)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 215",
    cx: 5.562,
    cy: 15.398,
    rx: 5.562,
    ry: 15.398,
    transform: "rotate(-69.134 745.892 417.584)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 1315",
    d: "M133.356 884.062a23.405 23.405 0 00-29.3 15.4c-3.838 12.344 6.622 57.531 6.622 57.531s34.24-31.288 38.078-43.632a23.405 23.405 0 00-15.4-29.299zm-10.242 32.936a11.087 11.087 0 1113.879-7.295 11.087 11.087 0 01-13.878 7.295z"
  }))));
}

export default SvgIconLocalisation;